<template>
  <div id="app">
    <v-app id="inspire">
      <router-view></router-view>
    </v-app>
  </div>
</template>

<script>
// import Home from './components/Home'

export default {
  name: "App",
  components: {
    // Home
  },
  data() {
    return {};
  },
  methods: {
    setUser: function() {
      this.$store.dispatch("setUser");
    },
    setLevel: function() {
      this.$store.dispatch("setLevel");
    }
  },
  created() {
    // when the app is created run the set user method
    // this uses Vuex to check if a user is signed in
    // check out mutations in the store.js file
    this.setUser();
    this.setLevel();
  }
};
</script>
